import type {
  SubjectActivityAuthorModel,
  SubjectActivityChangeModel,
  SubjectChangeActivityModel,
} from '@/lib/apollo/query/getSubjectChangeActivities/query'

export interface SubjectChangeActivity {
  id: string
  applicationId: string
  customerId: string
  type: string
  category: string
  source: SubjectActivitySource
  changes: SubjectActivityChange[]
  createdAt: Date
  author?: SubjectActivityAuthor
}

export interface SubjectActivityChange {
  fieldName: string
  path: string
  oldValue?: string
  newValue?: string
}

export interface SubjectActivityAuthor {
  type: string
  id?: string
  name?: string
  email?: string
}

export interface SubjectActivitySource {
  eventName: string
  metadata: SubjectActivitySourceMetadata
}

export interface SubjectActivitySourceMetadata {
  activityType: string
  section: string
}

export interface Response {
  getSubjectChangeActivities: SubjectChangeActivity[]
}

const toSubjectActivityChange = (
  change: SubjectActivityChangeModel,
): SubjectActivityChange => ({
  ...change,
  newValue: change.newValue ?? undefined,
  oldValue: change.oldValue ?? undefined,
})

const toSubjectActivityAuthor = (
  author: SubjectActivityAuthorModel,
): SubjectActivityAuthor => ({
  type: author.type,
  id: author.id ?? undefined,
  name: author.name ?? undefined,
  email: author.email ?? undefined,
})

export const toSubjectChangeActivity = (
  activity: SubjectChangeActivityModel,
): SubjectChangeActivity => ({
  ...activity,
  changes: activity.changes.map(toSubjectActivityChange),
  createdAt: new Date(activity.createdAt),
  author: activity.author ? toSubjectActivityAuthor(activity.author) : undefined,
})
